// extracted by css-extract-rspack-plugin
export default {"cls1":"EvaluationPage-cls1_ylm","cls2":"EvaluationPage-cls2_eUM EvaluationPage-cls1_ylm"};